import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import useStyles from './styles';

const SelectDropDown = ({
  onChange,
  value,
  items,
  selectClass,
  placeholder
}) => {
  const classes = useStyles();
  const [t] = useTranslation();
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <Select
      open={open}
      onClose={handleClose}
      onOpen={handleOpen}
      displayEmpty
      value={value}
      onChange={event => {
        onChange(event.target.value);
      }}
      className={classNames(classes.selectInput, selectClass)}
    >
      {placeholder && (
        <MenuItem value="" disabled className={classes.disabledMenuItem}>
          {t(placeholder)}
        </MenuItem>
      )}
      {items.map((item, index) => {
        return (
          <MenuItem
            style={item.value === value ? { backgroundColor: '#E2F5F8' } : {}}
            key={index}
            value={item.value}
          >
            {t(item.label)}
          </MenuItem>
        );
      })}
    </Select>
  );
};

export default SelectDropDown;
